import styled, { css, DefaultTheme } from 'styled-components';

import { ModeProps } from './types';

const modifier = {
	light: (theme: DefaultTheme) => css`
		background-color: ${theme.colors.white};
		color: ${theme.colors.portoSeguros100};
	`,
	dark: (theme: DefaultTheme) => css`
		background-color: ${theme.colors.black85};
		color: ${theme.colors.white};
	`,
};

export const Link = styled.a`
	all: unset;
	cursor: pointer;
	position: relative;
	overflow: hidden;
`;

export const Container = styled.div<ModeProps>`
	${({ theme, mode }) => css`
		padding: 2.3rem 2.4rem 2.9rem;
		display: flex;
		flex-direction: column;

		${!!mode && modifier[mode](theme)};
	`}
`;

export const Image = styled.img`
	${({ theme }) => css`
		width: 100%;
		height: auto;
		margin-bottom: 2.4rem;

		@media (min-width: ${theme.breakpoints.tabletPortrait}) {
			width: 28rem;
			height: 18.6rem;
			margin-bottom: 2.2rem;
		}

		@media (min-width: ${theme.breakpoints.tabletLandscape}) {
			width: 39rem;
			height: 18.6rem;
			margin-bottom: 2.2rem;
		}

		@media (min-width: ${theme.breakpoints.desktop}) {
			width: 37.5rem;
			height: 34.1rem;
			margin-bottom: 3rem;
		}

		@media (min-width: ${theme.breakpoints.ultraWide}) {
			width: 59.2rem;
			height: 45.3rem;
			margin-bottom: 5.7rem;
		}
	`}
`;

export const Heading = styled.div<ModeProps>`
	${({ theme, mode }) => css`
		margin-bottom: 2.4rem;
		${!!mode && modifier[mode](theme)};
	`}
`;

export const Text = styled.p<ModeProps>`
	${({ theme, mode }) => css`
		cursor: pointer;
		font-family: ${theme.font.family.portoRoobert};
		font-weight: ${theme.font.weight.semibold};
		font-size: 16px;
		line-height: 20px;
		letter-spacing: 0.025em;

		${!!mode && modifier[mode](theme)};

		@media (min-width: ${theme.breakpoints.desktop}) {
			font-weight: ${theme.font.weight.bold};
		}
	`}
`;

export const TextShimmer = styled.div<ModeProps>`
	${({ theme, mode }) => css`
		cursor: pointer;
		font-family: ${theme.font.family.portoRoobert};
		font-weight: ${theme.font.weight.semibold};
		font-size: 16px;
		line-height: 20px;
		letter-spacing: 0.025em;

		${!!mode && modifier[mode](theme)};

		@media (min-width: ${theme.breakpoints.desktop}) {
			font-weight: ${theme.font.weight.bold};
		}
	`}
`;
